// utils/formatNumber.ts
export const toCurrency = (num: number): string => {
    return num.toLocaleString(); // Formats the number with commas
};